const detectInitialLanguage = () => {
  if (typeof window !== 'undefined') {
    const match = window.location.pathname.match(/^\/(en|nl)(\/|$)/);
    if (match) return match[1].toUpperCase();
  }
  return 'FR';
};

export const globalLanguageState = {
  selectedLanguage: detectInitialLanguage(),
  listeners: new Set<Function>(),

  setSelectedLanguage(language: string) {
    this.selectedLanguage = language;
    this.listeners.forEach(listener => listener(language));
  },

  registerListener(listener: Function) {
    this.listeners.add(listener);
  },

  unregisterListener(listener: Function) {
    this.listeners.delete(listener);
  }
};
